// VG 2.0 · Phase 9 — VG Extended Network + Project Circle client.

const API = process.env.REACT_APP_BACKEND_URL;

// LAUNCH-C2 — PA auth via JWT Bearer (same as the PA workspace client).
// No X-PA-Id. Per-case authorization stays server-side.
function _headers() {
  const h = { "Content-Type": "application/json" };
  try {
    const token = window.localStorage.getItem("vg2_token");
    if (token) h["Authorization"] = `Bearer ${token}`;
  } catch (_) { /* noop */ }
  return h;
}

async function _handle(r) {
  if (!r.ok) {
    let detail;
    try { detail = await r.json(); } catch { detail = { detail: r.statusText }; }
    const err = new Error(
      (detail && detail.detail && detail.detail.message) ||
      (typeof detail?.detail === "string" ? detail.detail : r.statusText)
    );
    err.status = r.status;
    err.code = detail?.detail?.error_code || null;
    throw err;
  }
  return await r.json();
}

export async function getCircle({ paId, caseId }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/circle`,
    { method: "GET", headers: _headers(paId) },
  ));
}

export async function searchNetwork({ paId, caseId, roleNeedRef, specialization, areaLevel, areaLabel }) {
  const params = new URLSearchParams({ role_need_ref: roleNeedRef });
  if (specialization) params.set("specialization", specialization);
  if (areaLevel) params.set("area_level", areaLevel);
  if (areaLabel) params.set("area_label", areaLabel);
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/network/professionals?${params.toString()}`,
    { method: "GET", headers: _headers(paId) },
  ));
}

export async function listOwnProfessionals({ paId, caseId }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/own-professionals`,
    { method: "GET", headers: _headers(paId) },
  ));
}

export async function createOwnProfessional({ paId, caseId, payload }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/own-professionals`,
    { method: "POST", headers: _headers(paId), body: JSON.stringify(payload) },
  ));
}

export async function selectMember({ paId, caseId, payload }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/circle/members`,
    { method: "POST", headers: _headers(paId), body: JSON.stringify(payload) },
  ));
}

export async function transitionMember({ paId, caseId, memberId, payload }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/circle/members/${memberId}/status`,
    { method: "POST", headers: _headers(paId), body: JSON.stringify(payload) },
  ));
}

export async function replaceMember({ paId, caseId, memberId, payload }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/circle/members/${memberId}/replace`,
    { method: "POST", headers: _headers(paId), body: JSON.stringify(payload) },
  ));
}

export async function removeMember({ paId, caseId, memberId, payload }) {
  return _handle(await fetch(
    `${API}/api/v2/pa/cases/${caseId}/circle/members/${memberId}/remove`,
    { method: "POST", headers: _headers(paId), body: JSON.stringify(payload) },
  ));
}

export function newOperationId(prefix = "op") {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
